import { useAction } from '@src/redux/hooks/useAction';
import { useSelect } from '@src/redux/hooks/useSelect';
import { useAsync } from '@src/redux/hooks/useAsync';
import { updateRegistrations, validateTins } from './actions';
import { VALIDATE_TIN, UPDATE_TIN } from './constants';

const tindraftSelector = (state) => {
  return state;
};

export const usePostRegistration = {
  state: () => {
    return useSelect(tindraftSelector);
  },
  actions: () => {
    return {
      updateTin: useAction(updateRegistrations, {
        saga: useAsync(UPDATE_TIN),
      }),
      validateTin: useAction(validateTins, {
        saga: useAsync(VALIDATE_TIN),
      }),
    };
  },
};
